module.exports = __webpack_public_path__ + "img/cac-pr1.5d0e3797.svg";